export default (_that) => [
  {
    field: 'seq',
    width: 60,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'checkbox',
    width: 40,
    align: 'center',
    fixed: 'left',
    type: 'checkbox',
  },
  {
    field: 'defaultImageUrl',
    width: 120,
    title: _that.$l('INDEX.table_label_image') || '图片',
    align: 'center',
    fixed: 'left',
    slots: { default: 'defaultImageUrl' },
  },
  {
    title: _that.$l('table_label_borrow_date') || '外借日期',
    field: 'borrowDate',
    minWidth: 150,
    align: 'center',
    headerAlign: 'center',
    showHeaderOverflow: 'title',
  },
  {
    title: _that.$l('table_lable_return_date') || '归还日期',
    field: 'createDate',
    minWidth: 150,
    align: 'center',
    headerAlign: 'center',
    showHeaderOverflow: 'title',
  },
  {
    title: _that.$l('table_label_input_code') || '样品条码',
    field: 'inputCode',
    minWidth: 180,
    align: 'center',
    headerAlign: 'center',
    showHeaderOverflow: 'title',
  },
  {
    title: _that.$l('table_label_sample_style_no') || '样品款号',
    field: 'sampleStyleNo',
    minWidth: 180,
    align: 'center',
    headerAlign: 'center',
    showHeaderOverflow: 'title',
  },
  {
    title: _that.$l('table_label_sample_name_en') || '英文品名',
    field: 'sampleNameEn',
    minWidth: 180,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: 'title',
  },
  {
    title: _that.$l('table_label_sample_name') || '样品名称',
    field: 'sampleName',
    minWidth: 180,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: 'title',
  },
  {
    title: _that.$l('table_label_input_num') || '数量',
    field: 'inputNum',
    minWidth: 100,
    align: 'center',
    headerAlign: 'center',
    showHeaderOverflow: 'title',
  },
  {
    title: _that.$l('table_label_use_place') || '使用地点',
    field: 'usePlace',
    minWidth: 100,
    align: 'center',
    headerAlign: 'center',
    showHeaderOverflow: 'title',
  },
  {
    title: _that.$l('table_label_use_cust_name') || '客户名称',
    field: 'useCustName',
    minWidth: 180,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: 'title',
  },
  {
    title: _that.$l('table_label_use_factory_name') || '外借工厂',
    field: 'useFactoryName',
    minWidth: 180,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: 'title',
  },
  {
    title: _that.$l('table_label_use_sales_name') || '申请人名称',
    field: 'useSalesName',
    minWidth: 180,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: 'title',
  },
  {
    title: _that.$l('table_label_return_date') || '预计归还时间',
    field: 'returnDate',
    minWidth: 180,
    align: 'center',
    headerAlign: 'center',
    showHeaderOverflow: 'title',
  },
  {
    title: _that.$l('table_label_inv_num') || '样品剩余库存',
    field: 'invNum',
    minWidth: 180,
    align: 'center',
    headerAlign: 'center',
    showHeaderOverflow: 'title',
  },
  {
    title: _that.$l('table_label_sample_spec') || '成品规格',
    field: 'sampleSpec',
    minWidth: 180,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: 'title',
  },
  {
    title: _that.$l('table_label_fringe_size') || '流苏尺寸',
    field: 'fringeSize',
    minWidth: 180,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: 'title',
  },
  {
    title: _that.$l('table_label_sample_weight') || '产品重量',
    field: 'sampleWeight',
    minWidth: 180,
    align: 'center',
    headerAlign: 'center',
    showHeaderOverflow: 'title',
  },
  {
    title: _that.$l('table_label_sales_person_name') || '业务员',
    field: 'salesPersonName',
    minWidth: 180,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: 'title',
  },
  {
    title: _that.$l('table_label_positive_material') || '正面材质',
    field: 'positiveMaterial',
    minWidth: 180,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: 'title',
  },
  {
    title: _that.$l('table_label_center_material') || '中间材质',
    field: 'centerMaterial',
    minWidth: 180,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: 'title',
  },
  {
    title: _that.$l('table_label_back_material') || '背面材质',
    field: 'backMaterial',
    minWidth: 180,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: 'title',
  },
  {
    title: _that.$l('table_label_package_material') || '包边材质',
    field: 'packageMaterial',
    minWidth: 180,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: 'title',
  },
  {
    title: _that.$l('table_label_fill_material') || '填充材质',
    field: 'fillMaterial',
    minWidth: 180,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: 'title',
  },
  {
    title: _that.$l('table_label_other_fabrics') || '其他面料',
    field: 'otherFabrics',
    minWidth: 180,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: 'title',
  },
  {
    title: _that.$l('table_label_internal_price') || '内部成本:工厂价格',
    field: 'internalPrice',
    minWidth: 180,
    align: 'center',
    headerAlign: 'center',
    showHeaderOverflow: 'title',
  },
  {
    title: _that.$l('table_label_internal_FOB_price') || '内部成本:FOB价',
    field: 'internalFOBPrice',
    minWidth: 180,
    align: 'center',
    headerAlign: 'center',
    showHeaderOverflow: 'title',
  },
  {
    title: _that.$l('table_label_factory_prices') || '工厂价格',
    field: 'factoryPrices',
    minWidth: 180,
    align: 'center',
    headerAlign: 'center',
    showHeaderOverflow: 'title',
  },
  {
    title: _that.$l('table_label_factory_FOB_price') || 'FOB价',
    field: 'factoryFOBPrice',
    minWidth: 180,
    align: 'center',
    headerAlign: 'center',
    showHeaderOverflow: 'title',
  },
  {
    title: _that.$l('table_label_scm_name') || '工厂信息',
    field: 'scmName',
    minWidth: 180,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: 'title',
  },
  {
    title: _that.$l('table_label_sample_memo') || '备注',
    field: 'sampleMemo',
    minWidth: 300,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: 'title',
  },
  {
    title: _that.$l('table_label_createBy_name') || '创建人',
    field: 'createByName',
    minWidth: 180,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: 'title',
  },
]
